/**
 * utils3d - Three.js utilities for 3D scene setup and animation
 */

/* ___________________________________________________________________________
|                               I M P O R T S                                 |
|___________________________________________________________________________ */

import { toRadians} from '@js/utils'
import { TransformOptions} from '../types'
import * as THREE from 'three'

/* ___________________________________________________________________________
|                                M O D U L E                                  |
|___________________________________________________________________________ */

/**
 * Initialize model transform (position, rotation, scale)
 */
export const modelTransform = (
  model: THREE.Object3D,
  options: TransformOptions = {}
): void => {
  const position = options.position || { x: 0, y: 0, z: 0 }
  const rotation = options.rotation || { x: 0, y: 0, z: 0 }
  const scale = options.scale || 1

  model.translateOnAxis(new THREE.Vector3(1, 0, 0), position.x)
  model.translateOnAxis(new THREE.Vector3(0, 1, 0), position.y)
  model.translateOnAxis(new THREE.Vector3(0, 0, 1), position.z)
  model.rotateOnAxis(new THREE.Vector3(1, 0, 0), toRadians(rotation.x))
  model.rotateOnAxis(new THREE.Vector3(0, 1, 0), toRadians(rotation.y))
  model.rotateOnAxis(new THREE.Vector3(0, 0, 1), toRadians(rotation.z))

  if (typeof scale === 'number') {
    model.scale.set(scale, scale, scale)
  } else {
    model.scale.set(scale.x, scale.y, scale.z)
  }
}


